import '../runtime/utils/polyfills';

export default defineNuxtPlugin({
    name: 'polyfills',
    dependsOn: [],
    async setup(nuxtApp)
    {
    }
});
